import React, { Component } from 'react';
import Usuario from '../../Utils/Usuario';

import './LoggedUser.scss';

class LoggedUser extends Component {
    constructor() {
        super();
        this.state = {
        }
    }
    render() {
        return (
            <div className="ebs-logger-user">
                <div className="ebs-foto-perfil" name="meu-cadastro" style={{ backgroundImage: `url(${Usuario.getLoggedUser.foto})` }}>
                </div>
            </div>
        )
    }
}

export default LoggedUser;